import { FC } from "react";

import {
	LabelPosition,
	RHookFormNumberFieldWithLabel,
	EnhancedDropDownRHFWithLabel,
} from "@websential/cosmic-v20";
import { Box } from "@mui/material";

interface IBCEHTSettingInfoSetupFieldsPanel {
	yearsDDL: any;
	onYearSelectionChangeHandler:(selectedYear:any) => void
}
export const BCEHTSettingInfoSetupFieldsPanel: FC<
	IBCEHTSettingInfoSetupFieldsPanel
> = ({ yearsDDL,onYearSelectionChangeHandler }) => {
	return (
		<Box>
			<EnhancedDropDownRHFWithLabel
				selectName={"taxYear"}
				label="Year"
				labelPosition={LabelPosition.Top}
				// required
				testId={`taxYear`}
				items={yearsDDL}
				onSelectionChangeHandler={onYearSelectionChangeHandler}
			/>
			<RHookFormNumberFieldWithLabel
				label="Exemption Amount"
				id="exemptionAmount"
				testId={`exemptionAmount`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Notch Amount"
				id="notchAmount"
				testId={`notchAmount`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="rate 1 (%)"
				id="rate1"
				testId={`rate1`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="rate 2 (%)"
				id="rate2"
				testId={`rate2`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Installments From"
				id="installmentsFrom"
				testId={`installmentsFrom`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Charitable Excemption Amount"
				id="charitableExcemptionAmount"
				testId={`charitableExcemptionAmount`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Charitable Notch Amount"
				id="charitableNotchAmount"
				testId={`charitableNotchAmount`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Charitable Rate 1 (%)"
				id="charitableRate1"
				testId={`charitableRate1`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="charitableRate 2  (%)"
				id="charitableRate2"
				testId={`charitableRate2`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormNumberFieldWithLabel
				label="Charitable Installments From"
				id="charitableInstallmentsFrom"
				testId={`charitableInstallmentsFrom`}
				labelPosition={LabelPosition.Top}
			/>
		</Box>
	);
};
